<template>
  <EdroneModal
    :index="41001"
    :open="open"
    show-close-icon
    unique-id="ModalIntegrationRequired_EdroneModal"
    @close="emit('close')"
  >
    <div class="tw:flex tw:flex-col tw:gap-6">
      <EdroneHeader :desc="desc" :title="title" type="h2" />
      <div class="tw:flex tw:gap-2">
        <EdroneButton
          class="flex-fill"
          type="solid"
          unique-id="ModalIntegrationRequired__EdroneButton_confirm"
          @click="goToIntegrationPage"
        >
          {{ trans._common.actions.integrate }}
        </EdroneButton>
      </div>
    </div>
  </EdroneModal>
</template>
<script lang="ts" setup>
import EdroneModal from "edrone-components/EdroneModal.vue";
import EdroneButton from "edrone-components/EdroneButton.vue";
import { defineEmits } from "vue";
import EdroneHeader from "edrone-components/EdroneHeader.vue";
import { useRouter } from "vue-router";

interface Props {
  open: boolean;
  title: string;
  desc?: string;
  url: string;
}

const emit = defineEmits(["close"]);
const router = useRouter();

const { open, title, desc, url } = defineProps<Props>();

const goToIntegrationPage = () => {
  router.push({ path: url });
  emit("close");
};
</script>
